import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Custom dropdown component that uses portal
const DropdownMenu = ({ isOpen, onClose, buttonRef, children }) => {
	const [position, setPosition] = useState({ top: 0, left: 0 });
	const menuRef = useRef(null);

	useEffect(() => {
		if (isOpen && buttonRef.current) {
			const rect = buttonRef.current.getBoundingClientRect();
			setPosition({
				top: rect.bottom + window.scrollY + 8,
				left: rect.right + window.scrollX - 192, // 192px = w-48
			});
		}
	}, [isOpen, buttonRef]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				buttonRef.current && 
				!buttonRef.current.contains(event.target) &&
				menuRef.current &&
				!menuRef.current.contains(event.target)
			) {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}
	}, [isOpen, onClose, buttonRef]);

	if (!isOpen) return null;

	return createPortal(
		<div
			ref={menuRef}
			className="fixed w-48 bg-white shadow-xl rounded-md py-1 border border-gray-200"
			style={{
				top: position.top,
				left: position.left,
				zIndex: 999999,
			}}
		>
			{children}
		</div>,
		document.body
	);
};

export default DropdownMenu; 